import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import TableComplex from "../../../vapor/tableComplex";
import "./style.css";
import { columnsAssets } from "./columns";
import { useDispatch, useSelector } from "react-redux";
import { createAssetGroup, getAssetsList } from "../../../../store/actions/precog/assets";
import numeral from "numeral";
import Spinner from "../../../general/spinner";
import { FormattedMessage, useIntl } from "react-intl";
import AssetsDrawerDetail from "./drawerDetail";
import { Tooltip } from "antd";
import { Button } from "@ts-digital/vrc";

const Assets = ({isBusinessIdSelected, businessId}) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const assets = useSelector(state => state.precog.assets.list);
  const assetsLoading = useSelector(state => state.precog.assets?.status?.started);

  const [registrationType, setRegistrationType] = useState("");
  const [currentAccountDesc, setCurrentAccountDesc] = useState("");
  const [drawerAsset, setDrawerAsset] = useState(false);
  const [isUpdatedStopPlease, setIsUpdatedStopPlease] = useState(false);
  const [, setAssetsTotal] = useState(0);
  const [list, setList] = useState([]);
  const [isUpdateTable, setIsUpdateTable] = useState(false);
  const [checkedArticles, setCheckedArticles] = useState([]);
  const [checkedAccount, setCheckedAccount] = useState(null);
  const [groupedArticles, setGroupedArticles] = useState([]);
  const isSellingInvoice = useSelector(state => state.precog?.invoiceDetail?.data?.doc?.active);

  useEffect(() => {
    if (!drawerAsset || isUpdateTable){
      setIsUpdateTable(false);
      dispatch(getAssetsList());
    }
  }, [dispatch, drawerAsset, isUpdateTable]);

  useEffect(()=> {
    if (assets && assets.groupBy) {
      setRegistrationType(assets.groupBy);
    }
    const uuids = assets?.assetLines?.filter(a => {
      return !!a.parentId;
    }).map(el => el.uuid);

    setGroupedArticles(uuids || []);
  }, [assets]);

  useEffect(() => {
    let newTotal = 0;
    if (registrationType !== "" && assets?.assetLines?.length > 0) {
      if (registrationType === "article") {
        let newLines = [];
        assets.assetLines.map(line => {
          let itemIndex = newLines
            .map(item => item.accountCode)
            .indexOf(line.accountCode);
          if (itemIndex === -1) {
            if (line.articleDesc) {
              newLines.push({
                ...line,
                articles: [line]
              });
              newTotal = newTotal + line.amount;
            } else {
              newLines.push({
                ...line
              });
              newTotal = newTotal + line.amount;
            }
          } else {
            if (line.articleDesc) {
              newLines[itemIndex].articles = [
                ...newLines[itemIndex].articles,
                line
              ];
              newTotal = newTotal + line.amount;
            } else {
              newLines.push({
                ...line
              });
              newTotal = newTotal + line.amount;
            }
          }
          return newLines;
        });
        setAssetsTotal(newTotal);
        setList(newLines);
      } else {
        assets.assetLines.map(el => {
          newTotal = newTotal + el.amount;
          setCurrentAccountDesc(el.accountDesc);
          return newTotal;
        });
        setAssetsTotal(newTotal);
        setList(assets.assetLines);
      }
    }
  }, [assets, registrationType]);

  const onSelectChange = (newSelectedRowKeys, contoSelected) => {    
    if (!checkedAccount) {
      setCheckedAccount(contoSelected);
    }
    if (newSelectedRowKeys.length === 0) {
      setCheckedAccount(null);
    }
    setCheckedArticles(newSelectedRowKeys);
  };

  const rowSelection = (contoSelected) => {
    return {
      selectedRowKeys: checkedArticles.concat(groupedArticles),
      getCheckboxProps: (record) => {              
        return {
          disabled: !!record?.conto?.assetGroupName || (checkedAccount ? contoSelected !== checkedAccount : false)};
      },
      onChange: (newSelectedRowKeys) => {onSelectChange(newSelectedRowKeys, contoSelected);}
    };
  };

  const renderTableRow = (conto) => {
    return {
      key: conto?.uuid,
      checkedArticles:checkedArticles,      
      conto: conto,
      /** the list with active toggle */
      additionChargeList: conto.additionChargeList,
      cespite:
        <div className={"pre-cog-assets-description-cell"}>
          <div style={{ display: "flex", width: "100%", marginRight: 8 }}>
            <div style={{flexGrow: 1}}>
              {registrationType === "article" ? conto.articleDesc : conto.accountDesc}
            </div>
            {conto.parentId && <div>
              <FontAwesomeIcon icon={["far", "object-group"]} style={{ color: "#c9d9e8" }} />
            </div>}
          </div>
        </div>,
      assetGroupName: <div style={{ display: "flex", width: "100%", paddingRight: 8 }}>
        <div style={{flexGrow: 1}}>
          {conto.assetGroupName}
        </div>
        {conto.parentId && <div style={{color: "#5a6872"}}>
          {numeral(conto.assetGroupAmount).format("0,0.00")} €
        </div>}
      </div>,      
      subKindDesc: <div>{(conto?.parentId && conto?.assetGroupSubKindDesc) ? conto?.assetGroupSubKindDesc : conto?.subKindDesc ? conto.subKindDesc : "-"}</div>,
      fiscalCriteria:
        (conto?.parentId && conto?.assetGroupTaxDepreciationRateType) ?
          <div>
            <FormattedMessage id={`preCog.assetsTab.drawer.${conto.assetGroupTaxDepreciationRateType}`} values={{percentage: `${conto?.assetGroupTaxDepreciationRate ? numeral(conto?.assetGroupTaxDepreciationRate).format("0,0.00") : "-"}%` || "-%"}}/>
          </div > :
          conto?.taxDepreciationRateType ?
            <div>
              <FormattedMessage id={`preCog.assetsTab.drawer.${conto.taxDepreciationRateType}`} values={{percentage: `${conto?.taxDepreciationRate ? numeral(conto?.taxDepreciationRate).format("0,0.00") : "-"}%` || "-%"}}/>
            </div > :
            <div> - % </div>,
      amount: (
        <NumberFormat
          displayType={"input"}
          thousandSeparator={"."}
          decimalSeparator={","}
          className="conti-intrastat-total"
          placeholder="-"
          suffix={"€"}
          value={numeral(Math.abs(conto.amount)).format("0,0.00")}
          disabled={true}
        />
      ),
      checkConto: conto.checkConto ? <div className="preCog-detail-check-red-icon"><FontAwesomeIcon icon={["fas", "circle"]} /></div> : null,
      contoDetail: (
        <Tooltip title={!isBusinessIdSelected && <FormattedMessage id="preCog.assetsTab.drawer.disabled"/>} color={"rgb(0, 80, 117)"}>
          <FontAwesomeIcon
            title={intl.formatMessage({ id: "preCog.sections.cespiti.tooltip"})}
            onClick={() => {return isBusinessIdSelected ? setDrawerAsset(conto) : null;}}
            className={!isBusinessIdSelected ? "preCog-detail-remove-icon-disabled" :  "preCog-detail-remove-icon"}
            icon={["far", "external-link-square-alt"]}
          />
        </Tooltip>
      )
    };
  };

  const buildDataSource = (asset) => {
    if (registrationType === "article") {    
      const listAdditionalCharge = asset.articles.filter((el) => {
        if (el.hasAdditionalCharge) return el.uuid;
        return null;
      });        
      return asset.articles.map((conto, key) => renderTableRow({ ...conto, accountCode: asset.accountCode, additionChargeList: listAdditionalCharge }));
    } 
    return assets?.assetLines?.map((conto, key) => renderTableRow(conto));    
  };
  
  return (
    <div data-testid="Assets" style={{ display: "flex", flexDirection: "column" }}>
      {drawerAsset &&
        <AssetsDrawerDetail
          setIsUpdateTable={setIsUpdateTable}
          setCheckedAccount={setCheckedAccount}
          onClose={() => setDrawerAsset(false)}
          isAssetGroup={!!drawerAsset.parentId}
          visible={drawerAsset}
          assetsDetails={drawerAsset.parentId ? drawerAsset.parentId : drawerAsset.uuid}
          businessId={businessId}
        />
      }
      {!isSellingInvoice &&
          <div style={{display: "flex", justifyContent: "end"}}>
            <Button
              kind="primary"
              size="medium"
              disabled={
                checkedArticles.filter((x) => !groupedArticles.find((x2) => x === x2)).length <= 1}
              onClick={() => {                
                dispatch(createAssetGroup(checkedArticles)).then(res => {                  
                  setDrawerAsset({uuid: res, parentId: res});
                });
              }}
            >
              <FontAwesomeIcon icon={["far", "object-group"]} style={{paddingRight: 16}} />
              Nuovo cespite da selezione
            </Button>
          </div>
      }
    
      {assetsLoading ? <Spinner size="large" /> : <div>{registrationType !== "" && <div className="conti-contabili-table-new" style={{ marginTop: 16 }}>
        {registrationType === "article" ? list.map((asset,index) => {
          return <TableComplex
            key={index}
            selectedRowKeys={checkedArticles.concat(groupedArticles)}
            dataSource={buildDataSource(asset)}
            columns={columnsAssets(
              registrationType, asset.accountDesc, groupedArticles, isSellingInvoice, dispatch, isUpdatedStopPlease, setIsUpdatedStopPlease
            )}
            rowSelection={!isSellingInvoice && rowSelection(asset.accountCode)}
          />;
        }) : <TableComplex
          dataSource={buildDataSource()}
          columns={columnsAssets(
            registrationType, currentAccountDesc, null, isSellingInvoice, dispatch
          )}
        />}
      </div>}</div>}
    </div>
  );
};

export default Assets;
